import { apiAxios } from '@/lib/apiAxios';
const BASE = '/internal/driver-payouts';
export const fetchDriverPayouts = async (states) => {
    const params = states && states.length > 0 ? { state: states.join(',') } : undefined;
    return apiAxios.get(BASE, { params }).then((r) => r.data);
};
export const fetchDriverPayout = async (publicId) => apiAxios.get(`${BASE}/${publicId}`).then((r) => r.data);
export const addLedgerEntry = async ({ publicId, data, }) => apiAxios.post(`${BASE}/${publicId}/entries`, data).then((r) => r.data);
export const payDriverPayout = async ({ publicId, data, }) => apiAxios.post(`${BASE}/${publicId}/pay`, data).then((r) => r.data);
export const holdDriverPayout = async ({ publicId, reason, }) => apiAxios.post(`${BASE}/${publicId}/hold`, { reason }).then((r) => r.data);
export const releaseDriverPayout = async (publicId) => apiAxios.post(`${BASE}/${publicId}/release`, {}).then((r) => r.data);
export const cancelDriverPayout = async ({ publicId, reason, }) => apiAxios.post(`${BASE}/${publicId}/cancel`, { reason }).then((r) => r.data);
export const remindDriverPayout = async (publicId) => apiAxios.post(`${BASE}/${publicId}/remind`, {}).then((r) => r.data);
